import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { ToastrService } from 'ngx-toastr';
import { Pricing } from '../models/pricing.model';
import { TranslateService } from '@ngx-translate/core';
import { BaseService } from '../shared/services/base.service';
import { TranslationService } from '../shared/i18n/translation.service';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})

export class PricingService extends BaseService<Pricing> {
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
        }),
    };
    API_URL = `${environment.apiUrl}/Packages`;
    API_URLFind = `${environment.apiUrl}/Packages/Find`;
    API_URLGetAll = `${environment.apiUrl}/Packages`;
    API_URLAdd = `${environment.apiUrl}/Packages`;
    API_URLUpdate = `${environment.apiUrl}/Packages`;
    API_URLDelete = `${environment.apiUrl}/Packages`;
    API_URLGetById = `${environment.apiUrl}/Packages`;
    API_URLAddUserToPackage = `${environment.apiUrl}/Users/AddUserToPackage?packageReferenceId=`;
    API_URLAddUserToCourse = `${environment.apiUrl}/Users/AddUserToCourse?courseReferenceId=`;
    API_URLAddUserToService = `${environment.apiUrl}/Users/AddUserToService?serviceReferenceId=`;
    API_URLAddUserToLesson = `${environment.apiUrl}/Users/AddUserToLesson?lessonReferenceId=`;
    API_URLDeleteUserPackageNotPayed = `${environment.apiUrl}/Users/DeleteAllUserNotPaidItems?referenceId=`;
    API_URLGetAllUserPayments = `${environment.apiUrl}/Users/GetAllUserPaymentsForEndUser?isPaymentDone=`;
    API_URLGetUserCredit = `${environment.apiUrl}/Users/GetUserCredit`;
    constructor(@Inject(HttpClient) http, public toastr: ToastrService, public translationServices: TranslationService) {
        super(http, toastr, translationServices);

    }
    getAllPricingWithPlanDetail$(): Observable<any[]> {
        let url = `${this.API_URL}/${this.langId}/list/`;
        return this.http.get<any[]>(url).pipe(
            map((body: any) => body),
            catchError(() => of())
        )
    }
    getAllUserPayments$(isPaymentDone: boolean): Observable<any[]> {
        let url = `${this.API_URLGetAllUserPayments}${isPaymentDone}`;
        return this.http.get<any[]>(url).pipe(
            map((body: any) => body),
            catchError(() => of())
        )
    }
    getUserCredit$(): Observable<any[]> {
        let url = `${this.API_URLGetUserCredit}`;
        return this.http.get<any[]>(url).pipe(
            map((body: any) => body),
            catchError(() => of())
        )
    }

    selectPackage$(referenceId: string): Observable<any> {
        let url = `${this.API_URLAddUserToPackage}${referenceId}`;
        return this.http.post<any>(url, "").pipe(
            catchError(err => {
                this.toastr.error(err.error.error);
                return throwError(err.error);
            }),
        );
    }
    selectCourse$(referenceId: string): Observable<any> {
        let url = `${this.API_URLAddUserToCourse}${referenceId}`;
        return this.http.post<any>(url, "").pipe(
            catchError(err => {
                this.toastr.error(err.error.error);
                return throwError(err.error);
            }),
        );
    }
    selectLesson$(referenceId: string): Observable<any> {
        let url = `${this.API_URLAddUserToLesson}${referenceId}`;
        return this.http.post<any>(url, "").pipe(
            catchError(err => {
                this.toastr.error(err.error.error);
                return throwError(err.error);
            }),
        );
    }
    selectService$(referenceId: string): Observable<any> {
        let url = `${this.API_URLAddUserToService}${referenceId}`;
        return this.http.post<any>(url, "").pipe(
            catchError(err => {
                this.toastr.error(err.error.error);
                return throwError(err.error);
            }),
        );
    }
    removePackage$(referenceId: string): Observable<any> {
        let url = `${this.API_URLDeleteUserPackageNotPayed}${referenceId}`;
        return this.http.delete<any>(url).pipe(
            catchError(err => {
                console.error('CREATE ITEM', err);
                return of({ id: undefined });
            }),
        );
    }
}